import { createContext, useContext } from 'react';

/**
 * True when the canvas is mounted read-only (e.g. a document surface's
 * diagram tab). Per-node renderers read this to refuse entering text-edit mode — `readOnly`
 * on `CanvasEngine` only nulls the React Flow change handlers (structural edits
 * don't persist), but node text editing is local to each node component and
 * must check this flag to stay genuinely non-editable. Defaults to `false`
 * (interactive) so standalone editors are unaffected.
 */
export const CanvasReadOnlyContext = createContext<boolean>(false);

export function useCanvasReadOnly(): boolean {
  return useContext(CanvasReadOnlyContext);
}
